import { render } from "./PageLoader.vue?vue&type=template&id=aec1149e&scoped=true"
import script from "./PageLoader.vue?vue&type=script&lang=js"
export * from "./PageLoader.vue?vue&type=script&lang=js"

import "./PageLoader.vue?vue&type=style&index=0&id=aec1149e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aec1149e"]])

export default __exports__